import { useQuery } from '@tanstack/react-query';
import { getAttributes } from '../providers/productFinderAPI';
import { queryKeys } from './queryKeys';

export const useAttributes = (bearerToken: string, indexNames: string[], enabled = true) => {
  // Sort indexes to ensure consistent cache keys
  const sortedIndexNames = [...indexNames].sort((a, b) => a.localeCompare(b));

  return useQuery({
    queryKey: queryKeys.attributes(sortedIndexNames),
    queryFn: () => getAttributes(bearerToken, sortedIndexNames),
    enabled: enabled && !!bearerToken && indexNames.length > 0,
  });
};
